
import React, { useState, useEffect } from 'react';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import { useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar'
import CustomCard from '../components/CustomCard'
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Checkbox from '@mui/material/Checkbox';
import Drawer from '@mui/material/Drawer';
import moment from 'moment';
import ImageComponent from '../components/ImageComponent'
import CustomDrawer from '../components/CustomDrawer';
import Model from '../components/Model'
import ImageViewer from '../components/ImageViewer';
import { getReviewedKernal, getSubScans, getScanDetails, getScanPdf, getImageFromCanvas, getCanvasImgDataForArray } from '../utils/api';
import CircularProgress from '@mui/material/CircularProgress';
import TablePopup from '../components/TablePopup';
import QrPopup from '../components/QrPopup';
import { Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import TableComponent from '../components/Table'
import ConfusionMatrix from '../components/ConfusionMatrix';

const ScanDetails = () => {
  // const navigate = useNavigate();
  const rotatedTopImageUrlRef = useRef(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [scanDetails, setScanDetails] = useState({});
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingForChanges, setIsLoadingForChanges] = useState(true);
  const [isModelLoading, setIsModelLoading] = useState(false);
  const [cropImageUrls, setCropImageUrls] = useState(null);
  const [cropImageUrlsForBottom, setCropImageUrlsForBottom] = useState(null);
  const [isCanvasLoading, setIsCanvasLoading] = useState(false);
  const [isLoadingForImage, setIsLoadingForImage] = useState(false);
  const [kernelDetails, setKernalDetails] = useState(null);
  const [kernelDiamensions, setKernalDiamensions] = useState([]);
  const [scanID, SetScanID] = useState(null);
  // const [errorMessage, setErrorMessage] = useState('');
  const [subScanID, setSubScanID] = useState(null);
  const [processData, setProcessData] = useState(null);
  const [scanPDFDetails, setScanPDFDetails] = useState(null);
  const [classNameCard, setClassNameCard] = useState('');
  const [selectedButtonIndex, setSelectedButtonIndex] = useState(-1);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [isPopupOpenForTable, setPopupOpenForTable] = useState(false);
  const [isTableOpen, setIsTableOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [kernals, setKernals] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isTableOpenForMatrix, setIsTableOpenForMatrix] = useState(false);
  const [selectedIndices, setSelectedIndices] = useState([]);
  const [selectedIndicesForBottom, setSelectedIndicesForBottom] = useState([]);
  const [multipleBoxesUrl, setMultipleBoxesUrl] = useState('')
  const [multipleBoxesUrlForBottom, setMultipleBoxesUrlForBottom] = useState('')
  const [ledMultipleBoxesUrl, setLedMultipleBoxesUrl] = useState(null);
  const [ledMultipleBoxesUrlForBottom, setLedMultipleBoxesUrlForBottom] = useState(null);
  const [bottomImg, setBottomImg] = useState(null)
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [boundingBox, setBoundingBox] = useState([]);
  const [formattedRows, setFormattedRows] = useState([]);
  const [ledCropImageUrls, setLedCropImageUrls] = useState([]);
  const [ledCropImageUrlsForBottom, setLedCropImageUrlsForBottom] = useState([]);
  const [selectedRows, setSelectedRow] = useState([]);
  const [isRotateModalOpen, setIsRotateModalOpen] = useState(false);
  const [rotationAngle, setRotationAngle] = useState(0);
  const [rotatedTopImageUrl, setRotatedTopImageUrl] = useState(null);
  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  const rotatedCanvasRef = useRef(null);
  const [isRotateImageLoading, setIsRotateImageLoading] = useState(false);
  // const [responseJson, setResponseJson] = useState(null)
  // const [caturedWebp, setCapturedWebp] = useState(null)
  const columns = [
    {
      field: 'checkbox',
      headerName: '',
      width: 50,
      headerClassName: 'table-background',
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderHeader: () => (
        <Checkbox
          checked={formattedRows.length > 0 && selectedRows.length === formattedRows.length}
          onChange={handleSelectAllForExpansion}
          color="primary"
          inputProps={{ 'aria-label': 'select all' }}
        />
      ),
      renderCell: (params) => {
        return (
          <Checkbox
            checked={selectedRows.some((selectedRow) => selectedRow.review_id === params.row.review_id)}
            onChange={() => handleCheckboxChange(params.row)}
            color="primary"
            inputProps={{ 'aria-label': 'select checkbox' }}
          />
        );
      },
    },
    {
      field: 'user_name',
      headerName: 'Login ID',
      width: 150,
      headerClassName: 'table-background',
      editable: false,
    },
    {
      field: 'full_name',
      headerName: 'User Name',
      width: 150,
      headerClassName: 'table-background',
      editable: false,
      renderCell: (params) => {
        const firstName = params.row?.first_name || '';
        const lastName = params.row?.last_name || '';
        const fullName = `${firstName} ${lastName}`.trim();
        return <div>{fullName || 'N/A'}</div>;
      },
    },
    {
      field: "contact_info",
      headerClassName: 'table-background',
      headerName: "Phone/Email",
      width: 150,
      renderCell: (params) => {
        const phoneNumber = params.row?.phone_number;
        const email = params.row?.email;
        return <div>{phoneNumber || email || "N/A"}</div>;
      },
    },
    {
      field: 'scan_id',
      headerName: 'Scan ID',
      width: 150,
      headerClassName: 'table-background',
      editable: true,
    },
    {
      field: 'sub_scan_id',
      headerName: 'Sub Scan ID',
      width: 100,
      headerClassName: 'table-background',
      editable: true,
    },
    {
      field: 'review_index',
      headerName: 'Index',
      headerClassName: 'table-background',
      width: 100,
      editable: true,
    },
    {
      field: 'created_at',
      headerName: 'Date',
      headerClassName: 'table-background',
      width: 180,
      editable: true,
    },
    {
      field: 'original_class_name',
      headerName: 'Original ClassName',
      headerClassName: 'table-background',
      width: 150,
      editable: true,
    },
    {
      field: 'changed_class_name',
      headerName: 'Change ClassName',
      headerClassName: 'table-background',
      width: 150,
      editable: true,
    },
    {
      field: 'updated_by',
      headerName: 'Updated By',
      width: 150,
      headerClassName: 'table-background',
      editable: false,
    },
  ];

  const handleMenuClick = async (event) => {
    setAnchorEl(event.currentTarget);
    const payload = {
      scan_id: scanID,
      sub_scan_id: subScanID
    };
    const kernalsResponse = await getReviewedKernal(payload)
    setKernals(kernalsResponse?.data?.data)
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenPopup = async () => {
    try {
      setIsLoadingForChanges(true);
      setSelectedRow([]);

      const payload = { scan_id: scanID, sub_scan_id: subScanID };
      const kernalsResponse = await getReviewedKernal(payload);
      const freshKernals = kernalsResponse?.data?.data || [];
      setKernals(freshKernals);

      const formatted = freshKernals.map((row, index) => ({
        id: index,
        ...row,
        created_at: row.created_at
          ? moment(row.created_at).format('DD MMM, YYYY hh:mm A')
          : 'N/A',
      }));

      setFormattedRows(formatted);
      setPopupOpen(true);
    } catch (error) {
      console.error('Error occurred while fetching kernals:', error);
    } finally {
      setIsLoadingForChanges(false);
    }
  };

  const handleButtonClicked = () => {
    setIsDrawerOpen(true);
  };

  const handleCropImage = async (className) => {
    setSelectAllChecked(false);
    setSelectedIndices([]);
    setSelectedIndicesForBottom([]);
    setClassNameCard(className);
    setIsCanvasLoading(true);

    const payload = { scan_id: scanID, sub_scan_id: subScanID };

    // Fetch kernels in background
    getReviewedKernal(payload)
      .then(res => setKernals(res?.data?.data))
      .catch(console.error);

    const files = scanDetails?.scan_files || [];

    // ===== NORMAL IMAGES =====
    const topFile =
      files.find(f => {
        const name = f.file_name.toLowerCase();
        return name.includes('captured') &&
          !name.includes('bottom') &&
          !name.includes('led');
      }) ||
      files.find(f => {
        const name = f.file_name.toLowerCase();
        return name.includes('_cv_server') &&
          !name.includes('bottom') &&
          !name.includes('led');
      });

    const bottomFile =
      files.find(f => f.file_name?.includes('captured_bottom')) ||
      files.find(f => f.file_name.includes('_bottom_cv_server'));

    // ===== LED IMAGES =====
    const ledTopFile = files.find(f => f.file_name?.includes('captured_led'));
    const ledBottomFile = files.find(f => f.file_name?.includes('captured_bottom_led'));

    const capturedWebpUrl = rotatedTopImageUrlRef.current || topFile?.file_url || null;
    const capturedWebpUrlForBottom = bottomFile?.file_url || null;
    const capturedLedUrl = ledTopFile?.file_url || null;
    const capturedLedUrlForBottom = ledBottomFile?.file_url || null;

    setBottomImg(capturedWebpUrlForBottom);

    // ===== BOUNDING BOXES =====
    const boundingBoxStrings =
      getBoundingBoxByClassName(className)?.map(JSON.stringify) || [];

    const boundingBoxStringsForBottom =
      getBoundingBoxForBottomByClassName(className)?.map(JSON.stringify) || [];

    // ===== PARALLEL CROPPING =====
    const [
      croppedImages,
      croppedImagesForBottom,
      ledCroppedImages,
      ledCroppedImagesForBottom
    ] = await Promise.all([
      // Normal Top
      Promise.all(
        boundingBoxStrings.map(box =>
          capturedWebpUrl ? getImageFromCanvas(capturedWebpUrl, box, true) : null
        )
      ),

      // Normal Bottom
      Promise.all(
        boundingBoxStringsForBottom.map(box =>
          capturedWebpUrlForBottom
            ? getImageFromCanvas(capturedWebpUrlForBottom, box)
            : null
        )
      ),

      // LED Top
      Promise.all(
        boundingBoxStrings.map(box =>
          capturedLedUrl ? getImageFromCanvas(capturedLedUrl, box, true) : null
        )
      ),

      // LED Bottom
      Promise.all(
        boundingBoxStringsForBottom.map(box =>
          capturedLedUrlForBottom
            ? getImageFromCanvas(capturedLedUrlForBottom, box)
            : null
        )
      ),
    ]);

    // ===== SET STATE =====
    setCropImageUrls(croppedImages.filter(Boolean));
    setCropImageUrlsForBottom(croppedImagesForBottom.filter(Boolean));
    setLedCropImageUrls(ledCroppedImages.filter(Boolean));
    setLedCropImageUrlsForBottom(ledCroppedImagesForBottom.filter(Boolean));

    setIsCanvasLoading(false);
  };

  const showBoundingBoxes = async () => {
    setOpen(true);
    setIsLoadingForImage(true);

    try {
      const files = scanDetails?.scan_files || [];

      /* ================= NORMAL IMAGES ================= */

      // Normal TOP
      const capturedTopFile =
        files.find(f => {
          const name = f.file_name.toLowerCase();
          return name.includes('captured') &&
            !name.includes('bottom') &&
            !name.includes('led');
        }) ||
        files.find(f => {
          const name = f.file_name.toLowerCase();
          return name.includes('_cv_server') &&
            !name.includes('bottom') &&
            !name.includes('led');
        });

      const capturedTopUrl = rotatedTopImageUrlRef.current || capturedTopFile?.file_url || null;

      // Normal BOTTOM
      const capturedBottomFile =
        files.find(f => f.file_name?.includes('captured_bottom')) ||
        files.find(f => f.file_name.includes('_bottom_cv_server'));

      const capturedBottomUrl = capturedBottomFile?.file_url || null;

      /* ================= LED IMAGES ================= */

      // LED TOP
      const ledTopFile =
        files.find(f => f.file_name?.includes('captured_led')) ||
        files.find(f => f.file_name?.includes('_led_cv_server'));

      const ledTopUrl = ledTopFile?.file_url || null;

      // LED BOTTOM
      const ledBottomFile =
        files.find(f => f.file_name?.includes('captured_bottom_led')) ||
        files.find(f => f.file_name?.includes('_bottom_led_cv_server'));

      const ledBottomUrl = ledBottomFile?.file_url || null;

      /* ================= BOUNDING BOXES ================= */

      const selectedBoundingBox = selectedIndices;
      const selectedBoundingBoxForBottom = selectedIndicesForBottom;

      /* ================= PARALLEL CANVAS PROCESSING ================= */

      const [
        boxesUrl,
        boxesUrlForBottom,
        ledBoxesUrl,
        ledBoxesUrlForBottom
      ] = await Promise.all([
        // Normal TOP
        capturedTopUrl && selectedBoundingBox?.length
          ? getCanvasImgDataForArray(capturedTopUrl, selectedBoundingBox)
          : null,

        // Normal BOTTOM
        capturedBottomUrl && selectedBoundingBoxForBottom?.length
          ? getCanvasImgDataForArray(capturedBottomUrl, selectedBoundingBoxForBottom)
          : null,

        // LED TOP
        ledTopUrl && selectedBoundingBox?.length
          ? getCanvasImgDataForArray(ledTopUrl, selectedBoundingBox)
          : null,

        // LED BOTTOM
        ledBottomUrl && selectedBoundingBoxForBottom?.length
          ? getCanvasImgDataForArray(ledBottomUrl, selectedBoundingBoxForBottom)
          : null
      ]);

      /* ================= SET STATE ================= */

      setMultipleBoxesUrl(boxesUrl);
      setMultipleBoxesUrlForBottom(boxesUrlForBottom);
      setLedMultipleBoxesUrl(ledBoxesUrl);
      setLedMultipleBoxesUrlForBottom(ledBoxesUrlForBottom);

    } catch (error) {
      console.error('Error showing bounding boxes:', error);
    } finally {
      setIsLoadingForImage(false);
    }
  };

  const getBoundingBoxByClassName = (className) => {
    if (processData?.bboxes && processData?.bboxes.hasOwnProperty(className)) {
      return processData?.bboxes[className];
    }
    return null;
  };

  const getBoundingBoxForBottomByClassName = (className) => {
    if (processData?.bboxes_bottom && processData?.bboxes_bottom.hasOwnProperty(className)) {
      return processData?.bboxes_bottom[className];
    }
    return null;
  };

  useEffect(() => {
    const fetchScans = async () => {
      try {
        setIsLoading(true);
        const path = window.location.pathname;
        const regex = /\/scan\/([^/]+)-(\d+)/;
        const match = path.match(regex);
        if (match && match.length === 3) {
          const scanID = match[1];
          const subScanID = parseInt(match[2], 10);
          SetScanID(scanID);
          setSubScanID(subScanID);
          const payload = {
            scan_id: scanID,
            sub_scan_id: subScanID,
          };
          const scanData = await getScanDetails(payload)
          if (scanData.status === 500) {
            // const response = await getResponseJsonOfFailScan([scanID]);
            // if (response?.data) {
            //   setResponseJson(response?.data[0]?.files.response)
            //   setCapturedWebp(response?.data[0]?.files.captured)
            // }
            // setErrorMessage(scanData)
          }

          if (scanData?.data) {
            const scandetails = scanData?.data?.data[0]
            setScanDetails(scandetails)
            setKernalDetails(scandetails?.kernel_details)
            setProcessData({
              ...scandetails?.processed_image,
              bboxes_bottom: scandetails?.cropped_kernel_details?.bboxes_bottom ?? null,
            });
            const titleCase = (s) => s.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase());
            let user_metadata_keys_array_filtered = []
            if (scandetails?.user_metadata) {
              const user_metadata_keys_array = Object.keys(scandetails?.user_metadata)
              user_metadata_keys_array_filtered = user_metadata_keys_array.filter((key) => scandetails?.user_metadata[key] !== "")
            }

            const dist_avg_indexes = scandetails?.dist_avg_indexes;
            const dist_keys_array = dist_avg_indexes?.distribution_avg_values_keys;
            const final_array = [...user_metadata_keys_array_filtered, ...dist_keys_array]
            const kernelAvgHeight = parseFloat(dist_avg_indexes?.distribution_avg_values?.kernel_avg_height);
            const kernelAvgWidth = parseFloat(dist_avg_indexes?.distribution_avg_values?.kernel_avg_width);
            let lbRatio = null;
            if (!isNaN(kernelAvgHeight) && !isNaN(kernelAvgWidth) && scanData?.data?.crop_details?.crop === "Rice") {
              lbRatio = (kernelAvgHeight / kernelAvgWidth).toFixed(2);
              const lbRatioKey = 'L/B Ratio';
              const lbIndex = final_array.indexOf('kernel_avg_width') + 1;
              final_array.splice(lbIndex, 0, lbRatioKey);
            }
            const resultArray = [];
            final_array.forEach((key) => {
              if (key === 'L/B Ratio' && lbRatio !== null) {
                resultArray.push(`L/B Ratio: ${lbRatio}`)
              }
              const user_metadata = scandetails?.user_metadata || {}
              if (key in dist_avg_indexes?.beautify?.translations?.distribution_avg_values) {
                const translation = dist_avg_indexes?.beautify?.translations?.distribution_avg_values[key];
                const value = dist_avg_indexes?.distribution_avg_values[key] || "NA";
                const dimension = dist_avg_indexes?.beautify?.dimensions?.distribution_avg_values[key] || "";
                resultArray.push(`${translation}: ${value} ${dimension}`)
              } else if (key in user_metadata) {
                const translation = titleCase(key);
                const value = scandetails?.user_metadata[key];
                resultArray.push(`${translation}: ${value}`)
              }
              setKernalDiamensions(resultArray)
            });
          }

        }
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    };
    fetchScans();
  }, [window.location.pathname]);

  useEffect(() => {
    if (!scanID || !subScanID) return;

    const fetchPdf = async () => {
      try {
        const scanPdf = await getScanPdf(scanID, subScanID);
        if (scanPdf) {
          setScanPDFDetails(scanPdf);
        }
      } catch (error) {
        console.error("PDF fetch failed", error);
      }
    };

    fetchPdf();
  }, [scanID, subScanID]);

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  // const handleClick = () => {
  //   navigate('/scans');
  // };
  // const downloadWebp = async () => {
  //   const response = await fetch(caturedWebp?.file_url);
  //   const blob = await response.blob();
  //   const url = URL.createObjectURL(blob);
  //   const link = document.createElement('a');
  //   link.href = url;
  //   link.download = `${scanID}_${subScanID}_captured.webp`;
  //   link.click();
  // };

  // if (errorMessage) {
  //   return (
  //     <>
  //       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
  //         <IconButton sx={{ color: '#2e7d32' }} onClick={handleClick}>
  //           <ArrowBackIcon />
  //         </IconButton>
  //         {errorMessage && (
  //           <p style={{ marginLeft: '8px', textAlign: 'center' }}>
  //             There is no Scan to show.
  //           </p>
  //         )}
  //       </div>
  //       {responseJson ?
  //         <div style={{ marginTop: "20px" }}>
  //           <iframe src={responseJson.file_url} style={{ width: '100%', height: '200px' }}></iframe>
  //         </div> :
  //         <p style={{ marginLeft: '8px', textAlign: 'center' }}>
  //           There is no Response.json to show.
  //         </p>
  //       }
  //       {caturedWebp ?
  //         (<div style={{ marginTop: "20px" }}>
  //           <Button variant="contained" color="success" onClick={downloadWebp}>
  //             Download Captured.Webp
  //           </Button>
  //         </div>) :
  //         <p style={{ marginLeft: '8px', textAlign: 'center' }}>
  //           There is no Captured.Webp to show.
  //         </p>
  //       }
  //     </>
  //   );
  // }
  const handleCheckboxClick = async (className, index) => {
    const boundingBox = getBoundingBoxByClassName(className);
    const boundingBoxForBottom = getBoundingBoxForBottomByClassName(className);
    setBoundingBox(boundingBox)
    if (index != null) {
      if (selectedIndices.length === boundingBox.length) {
        setSelectedIndices([]);
        return
      }
      if (selectedIndicesForBottom?.length !== null && boundingBoxForBottom?.length !== null && selectedIndicesForBottom?.length === boundingBoxForBottom?.length) {
        setSelectedIndicesForBottom([]);
        return;
      }
      const selectedIndex = boundingBox[index];
      if (selectedIndices.includes(selectedIndex)) {
        setSelectedIndices(selectedIndices.filter(i => i !== selectedIndex));
      } else {
        setSelectedIndices([...selectedIndices, selectedIndex]);
      }
      const selectedIndexForBottom = boundingBoxForBottom && boundingBoxForBottom[index];
      if (selectedIndicesForBottom.includes(selectedIndexForBottom)) {
        setSelectedIndicesForBottom(selectedIndicesForBottom.filter(i => i !== selectedIndexForBottom));
      } else {
        setSelectedIndicesForBottom([...selectedIndicesForBottom, selectedIndexForBottom]);
      }
    } else {
      if (selectedIndices.length === boundingBox.length) {
        setSelectedIndices([]);
        return
      } else {
        setSelectedIndices(boundingBox);
      }
      if (selectedIndicesForBottom?.length !== null && boundingBoxForBottom?.length !== null && selectedIndicesForBottom?.length === boundingBoxForBottom?.length) {
        setSelectedIndicesForBottom([]);
        return
      } else {
        setSelectedIndicesForBottom(boundingBoxForBottom);
      }
    }

  };

  const openModal = async () => {
    setIsModelLoading(true)
    setModalOpen(true);
    const response = await getSubScans(scanID);
    response?.data?.data && setModalData(response.data.data);
    setIsModelLoading(false);
  };

  const handleCheckboxChange = (row) => {
    setSelectedRow((prev) => {
      const isSelected = prev.some((r) => r.review_id === row.review_id);
      if (isSelected) {
        return prev.filter((r) => r.review_id !== row.review_id);
      } else {
        return [...prev, row];
      }
    });
  };

  const handleSelectAllForExpansion = () => {
    if (selectedRows.length === formattedRows.length) {
      setSelectedRow([]);
    } else {
      setSelectedRow(formattedRows);
    }
  };

  const handleDownloadJSON = () => {
    if (!selectedRows || selectedRows.length === 0) return;

    const json = JSON.stringify(selectedRows, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${scanID}_${subScanID}_review.json`;
    link.click();
    URL.revokeObjectURL(url);
  };

  const getTopImageUrl = () => {
    const files = scanDetails?.scan_files || [];
    const topFile =
      files.find(f => {
        const name = f.file_name.toLowerCase();
        return name.includes('captured') &&
          !name.includes('bottom') &&
          !name.includes('led');
      }) ||
      files.find(f => {
        const name = f.file_name.toLowerCase();
        return name.includes('_cv_server') &&
          !name.includes('bottom') &&
          !name.includes('led');
      });
    return topFile?.file_url || null;
  };

  const handleOpenRotateModal = () => {
    const url = rotatedTopImageUrl || getTopImageUrl();
    setPreviewImageUrl(url);
    setRotationAngle(0);
    setIsRotateImageLoading(true);
    setIsRotateModalOpen(true);
  };

  const drawRotatedImage = (img, angle) => {
    const canvas = rotatedCanvasRef.current;
    if (!canvas) return;
    const rad = (angle * Math.PI) / 180;
    const sin = Math.abs(Math.sin(rad));
    const cos = Math.abs(Math.cos(rad));
    const fullW = img.width * cos + img.height * sin;
    const fullH = img.width * sin + img.height * cos;
    const maxW = window.innerWidth * 0.70;
    const maxH = window.innerHeight * 0.60;
    const scale = Math.min(maxW / fullW, maxH / fullH, 1);
    canvas.width = Math.round(fullW * scale);
    canvas.height = Math.round(fullH * scale);
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(rad);
    ctx.scale(scale, scale);
    ctx.drawImage(img, -img.width / 2, -img.height / 2);
  };

  const handleRotate = (direction) => {
    const newAngle = rotationAngle + (direction === 'right' ? 90 : -90);
    setRotationAngle(newAngle);
    const img = document.getElementById('rotate-source-img');
    if (img) drawRotatedImage(img, newAngle);
  };

  const handleSaveRotatedImage = () => {
    const img = document.getElementById('rotate-source-img');
    if (!img) return;
    const rad = (rotationAngle * Math.PI) / 180;
    const sin = Math.abs(Math.sin(rad));
    const cos = Math.abs(Math.cos(rad));
    const fullW = img.naturalWidth * cos + img.naturalHeight * sin;
    const fullH = img.naturalWidth * sin + img.naturalHeight * cos;
    const fullCanvas = document.createElement('canvas');
    fullCanvas.width = Math.round(fullW);
    fullCanvas.height = Math.round(fullH);
    const ctx = fullCanvas.getContext('2d');
    ctx.translate(fullCanvas.width / 2, fullCanvas.height / 2);
    ctx.rotate(rad);
    ctx.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);
    const rotatedUrl = fullCanvas.toDataURL('image/png');
    rotatedTopImageUrlRef.current = rotatedUrl;
    setRotatedTopImageUrl(rotatedUrl);
    setIsRotateModalOpen(false);
  };

  const handleCancelRotate = () => {
    setIsRotateModalOpen(false);
    setRotationAngle(0);
  };

  return (
    <div className="scan-content-container">
      <Sidebar scanID={scanID} subScanID={subScanID} isArrow />
      <div className="scan-container">
        <div className="back-arrow" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
          </div>
          {kernelDetails?.overall_score !== null &&
            kernelDetails?.overall_score !== undefined && (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px' }}>
                <Button variant="outlined" color="success">
                  Overall Score: {kernelDetails?.overall_score}
                </Button>
              </div>
            )}
          <div style={{ display: 'flex' }}>
            <Button color="success" variant="outlined" onClick={() => openModal()} style={{ marginRight: '10px' }}> Get Sub Scans</Button>
            <Button color="success" variant="outlined" onClick={handleButtonClicked}> Get Files</Button>
          </div>
          {modalOpen && (
            <Model open={modalOpen} onClose={() => setModalOpen(false)} title={`Select Sub Scan For ${scanID}`} data={modalData} scanID={scanID} subScanID={subScanID} isLoading={isModelLoading} />
          )}
        </div>
        <div className="scan-content">
          <CustomCard scanDetails={scanDetails} kernelDiamensions={kernelDiamensions} isLoading={isLoading} />
        </div>
        {
          (kernelDetails?.total_kernel_count || kernelDetails?.total_kernel_weight) && (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }}>
              <div>
                {kernelDetails?.total_kernel_count && (
                  <Button variant="outlined" color="success" style={{ marginRight: '20px' }}>
                    Kernel Count: {kernelDetails?.total_kernel_count}
                  </Button>
                )}
                {kernelDetails?.total_kernel_weight && (
                  <Button variant="outlined" color="success">
                    Predicted kernel Weight: {kernelDetails?.total_kernel_weight} gm
                  </Button>
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                <Button variant="outlined" color="success" onClick={() => showBoundingBoxes()}>
                  View All Kernels
                </Button>
                <IconButton
                  color="success"
                  onClick={handleOpenRotateModal}
                  title="Rotate Image"
                  size="small"
                >
                  <RotateRightIcon />
                </IconButton>
                {rotatedTopImageUrl && (
                  <Button
                    variant="text"
                    color="error"
                    size="small"
                    onClick={() => { rotatedTopImageUrlRef.current = null; setRotatedTopImageUrl(null); }}
                    title="Reset to original image"
                  >
                    Reset Rotation
                  </Button>
                )}
                <label>
                  <input
                    type="checkbox"
                    checked={selectedIndices?.length !== 0 && selectedIndices?.length === parseInt(kernelDetails?.kernel_counts[classNameCard])}
                    onChange={() => handleCheckboxClick(classNameCard)}
                  />
                  Select All
                </label>
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  onClick={handleMenuClick}
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem onClick={handleClose}><Button variant="outlined" color="success" onClick={handleOpenPopup}>
                    View Changes
                  </Button></MenuItem>
                  <MenuItem onClick={handleClose}><Button variant="outlined" color="success" onClick={() => setIsTableOpen(true)}>
                    View Table
                  </Button></MenuItem>
                  <MenuItem onClick={handleClose}><Button variant="outlined" color="success" onClick={() => setIsTableOpenForMatrix(true)}>
                    View Confusion Matrix
                  </Button></MenuItem>
                  <MenuItem onClick={handleClose}><Button variant="outlined" color="success" onClick={() => setPopupOpenForTable(true)}>
                    View Legend
                  </Button></MenuItem>
                </Menu>
              </div>
              {open && (
                <>
                  <ImageViewer
                    open={open}
                    isLoading={isLoadingForImage}
                    onClose={handleCloseModal}
                    title="Image Viewer"
                    imageUrl={multipleBoxesUrl}
                    imageUrlForBottom={multipleBoxesUrlForBottom}
                    ledMultipleBoxesUrl={ledMultipleBoxesUrl}
                    ledMultipleBoxesUrlForBottom={ledMultipleBoxesUrlForBottom}
                    imageAlt={'captured Image'}
                    imageAltForBottom={'Bottom captured Image'}
                  />
                </>
              )}
              {isTableOpenForMatrix && <ConfusionMatrix open={isTableOpenForMatrix} onClose={() => setIsTableOpenForMatrix(false)} kernals={kernals} scanDetails={scanDetails} scanID={scanID} subScanID={subScanID} title='View Confusion Matrix' />}
              {isTableOpen && <TableComponent open={isTableOpen} onClose={() => setIsTableOpen(false)} scanDetails={scanDetails} kernals={kernals} scanID={scanID} subScanID={subScanID} title='View Table' />}
              {isPopupOpenForTable && <TablePopup open={isPopupOpenForTable} onClose={() => setPopupOpenForTable(false)} encoding_colors={processData} scan_result={kernelDetails} title='View Legend' dynamicTableForLegend />}
              {isPopupOpen && <QrPopup open={isPopupOpen} onClose={() => setPopupOpen(false)} title='View Changes' rows={formattedRows} expandedColumns={columns} scanID={scanID} subScanID={subScanID} tabledata isLoadingForChanges={isLoadingForChanges} selectedRowsForExpansion={selectedRows}
                handleDownloadForExpansion={handleDownloadJSON} />}
            </div>
          )
        }
        <div className="tab-content">
          {kernelDetails?.classes && kernelDetails.classes.map((className, index) => (
            <React.Fragment key={index}>
              <Button
                style={{
                  color: 'black',
                  border: `3px solid ${processData?.encoding_colors[className]}`,
                  ...(classNameCard === className && {
                    background: `${processData?.encoding_colors[className]}`,
                    color: 'white'
                  })
                }}
                onClick={() => {
                  setSelectedButtonIndex(index);
                  handleCropImage(className);
                }}
              >
                {`${className.replace(/_/g, ' ')} - ${processData?.encodings[className]} - ${kernelDetails?.kernel_counts[className] !== null ? kernelDetails?.kernel_counts[className] : 0}`}
              </Button>
            </React.Fragment>
          ))}
        </div>
        <div>
          {isCanvasLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <div>
                {cropImageUrls && cropImageUrls.length > 0 ? (
                  <div className='tab-content'>
                    {cropImageUrls && cropImageUrls.map((imageUrl, index) => (
                      <React.Fragment key={`${imageUrl}-${index}`}>
                        <ImageComponent
                          key={index}
                          index={index}
                          imageUrl={imageUrl}
                          imageUrlForBottom={cropImageUrlsForBottom ? cropImageUrlsForBottom[index] : ''}
                          ledImageUrl={ledCropImageUrls?.[index] || null}
                          ledImageUrlForBottom={ledCropImageUrlsForBottom?.[index] || null}
                          kernelDetails={kernelDetails}
                          classNameCard={classNameCard}
                          processData={processData}
                          selectedButtonIndex={selectedButtonIndex}
                          handleCropImage={handleCropImage}
                          scanId={scanID}
                          text={bottomImg ? 'Top' : ''}
                          selectedIndices={selectedIndices}
                          setSelectedIndices={setSelectedIndices}
                          subScanId={subScanID}
                          scanDetails={scanDetails}
                          kernals={kernals}
                          bottomImg={bottomImg}
                          handleCheckboxClick={handleCheckboxClick}
                          boundingBox={boundingBox}
                          setKernals={setKernals}
                          selectAllChecked={selectAllChecked}
                          rotatedTopImageUrl={rotatedTopImageUrl}
                        />
                      </React.Fragment>
                    ))}
                  </div>
                ) : (
                  cropImageUrls && cropImageUrls.length === 0 ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <p>There is no image to show.</p>
                    </div>
                  ) : (
                    kernelDetails?.classes &&
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <p>Please Select Class</p>
                    </div>
                  )
                )}
              </div>
            </>
          )}
        </div>
      </div>
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={handleDrawerClose}
        PaperProps={{
          sx: {
            width: '25%',
            backgroundColor: '#f5f5f5',
          },
        }}
      >
        <CustomDrawer onClose={handleDrawerClose} scanID={scanID} subScanID={subScanID} sacnFiles={scanDetails?.scan_files} scanPDFDetails={scanPDFDetails} isLoading={isLoading} scanDetails={scanDetails} />
      </Drawer>
      {isRotateModalOpen && (
        <div style={{
          position: 'fixed', inset: 0,
          background: 'rgba(0,0,0,0.75)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <div style={{
            background: 'white',
            borderRadius: '8px',
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
            maxWidth: '90vw',
            maxHeight: '90vh',
          }}>
            <h3 style={{ margin: 0, color: '#2e7d32' }}>Rotate Image</h3>

            {/* Hidden source image */}
            <img
              id="rotate-source-img"
              src={previewImageUrl}
              crossOrigin="anonymous"
              style={{ display: 'none' }}
              onLoad={(e) => {
                drawRotatedImage(e.target, rotationAngle);
                setIsRotateImageLoading(false);
              }}
              onError={() => setIsRotateImageLoading(false)}
              alt="source"
            />

            {/* Canvas preview */}
            <div style={{ width: '70vw', height: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #ccc', background: '#f5f5f5', overflow: 'hidden', position: 'relative' }}>
              {isRotateImageLoading && (
                <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                  <CircularProgress color="success" />
                  <p style={{ margin: 0, color: '#666', fontSize: '13px' }}>Loading image...</p>
                </div>
              )}
              <canvas
                ref={rotatedCanvasRef}
                style={{ display: isRotateImageLoading ? 'none' : 'block' }}
              />
            </div>
            {/* Rotate buttons */}
            <div style={{ display: 'flex', gap: '12px' }}>
              <Button
                variant="outlined"
                color="success"
                onClick={() => handleRotate('left')}
                startIcon={<RotateRightIcon style={{ transform: 'scaleX(-1)' }} />}
              >
                Rotate Left
              </Button>
              <Button
                variant="outlined"
                color="success"
                onClick={() => handleRotate('right')}
                startIcon={<RotateRightIcon />}
              >
                Rotate Right
              </Button>
            </div>

            <p style={{ margin: 0, color: '#666', fontSize: '13px' }}>
              Current rotation: {((rotationAngle % 360) + 360) % 360}°
            </p>

            {/* Save / Cancel */}
            <div style={{ display: 'flex', gap: '12px' }}>
              <Button variant="contained" color="success" onClick={handleSaveRotatedImage}>
                Save & Use for Cropping
              </Button>
              <Button variant="outlined" color="error" onClick={handleCancelRotate}>
                Cancel
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>

  );
};

export default ScanDetails;
